/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { AwardedLaneFragmentDoc } from '../../../graphql/AwardedLaneFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipperRateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']
}>

export type IShipperRateQuery = { __typename?: 'Query' } & {
  shipperRate?: Types.Maybe<
    { __typename?: 'ShipperRate' } & Pick<
      Types.IShipperRate,
      | 'id'
      | 'carrierMarketRate'
      | 'datMiles'
      | 'shipperLaneId'
      | 'volume'
      | 'volumeType'
      | 'deliveryCity'
      | 'deliveryStateCode'
      | 'deliveryRegion'
      | 'endDate'
      | 'isDeliveryDropTrailer'
      | 'isPickupDropTrailer'
      | 'pickupCity'
      | 'pickupStateCode'
      | 'pickupRegion'
      | 'sourcedCarrierRatesCount'
      | 'sourceStatus'
      | 'startDate'
      | 'weeklyVolume'
    > & {
        listingDetails?: Types.Maybe<
          { __typename?: 'ShipperRateListingDetails' } & Pick<
            Types.IShipperRateListingDetails,
            'id' | 'commodity' | 'maxWeight' | 'minWeight' | 'note' | 'offerLeadTime'
          >
        >
        rate?: Types.Maybe<
          { __typename?: 'Rate' } & Pick<Types.IRate, 'id' | 'amount' | 'rateTypeKey'>
        >
        requestForProposalLaneFeedback?: Types.Maybe<
          { __typename?: 'RequestForProposalLaneFeedback' } & Pick<
            Types.IRequestForProposalLaneFeedback,
            'id' | 'tttAtAward'
          > & {
              requestForProposalLanePrice: { __typename?: 'RequestForProposalLanePrice' } & Pick<
                Types.IRequestForProposalLanePrice,
                'id' | 'tfxhAllIn'
              > & {
                  requestForProposalLane: { __typename?: 'RequestForProposalLane' } & Pick<
                    Types.IRequestForProposalLane,
                    'id'
                  > & {
                      requestForProposal?: Types.Maybe<
                        { __typename?: 'RequestForProposal' } & Pick<
                          Types.IRequestForProposal,
                          'id' | 'googleSheetsUrl' | 'salesforceRfpId' | 'auditWorkspace'
                        >
                      >
                    }
                }
            }
        >
        shipperRateShipperFacilities: Array<
          { __typename?: 'ShipperRateShipperFacility' } & Pick<
            Types.IShipperRateShipperFacility,
            'id' | 'stopType'
          > & {
              shipperFacility: { __typename?: 'ShipperFacility' } & Pick<
                Types.IShipperFacility,
                'id' | 'uuid'
              > & {
                  facility: { __typename?: 'Facility' } & Pick<Types.IFacility, 'id' | 'name'> & {
                      location: { __typename?: 'Location' } & Pick<
                        Types.ILocation,
                        'id' | 'address' | 'city' | 'stateCode' | 'zipcode'
                      >
                    }
                  hours: Array<
                    { __typename?: 'FacilityScheduleHour' } & Pick<
                      Types.IFacilityScheduleHour,
                      'id' | 'closed' | 'day' | 'endTime' | 'startTime' | 'stopType' | 'unloadType'
                    >
                  >
                }
            }
        >
        carrierSalesRep?: Types.Maybe<
          { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
        >
        deliveryLocation?: Types.Maybe<
          { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
        >
        equipment?: Types.Maybe<
          { __typename?: 'Equipment' } & Pick<
            Types.IEquipment,
            'id' | 'key' | 'name' | 'parentKey'
          > & { parent?: Types.Maybe<{ __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id'>> }
        >
        pickupLocation?: Types.Maybe<
          { __typename?: 'Location' } & Pick<Types.ILocation, 'id' | 'city' | 'stateCode'>
        >
        shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
          Types.IShipperApplication,
          'id' | 'name'
        >
      }
  >
}

export const ShipperRateDocument = gql`
  query ShipperRate($id: ID!) {
    shipperRate(id: $id) {
      ...AwardedLane
    }
  }
  ${AwardedLaneFragmentDoc}
`

/**
 * __useShipperRateQuery__
 *
 * To run a query within a React component, call `useShipperRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipperRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipperRateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShipperRateQuery(
  baseOptions: Apollo.QueryHookOptions<IShipperRateQuery, IShipperRateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShipperRateQuery, IShipperRateQueryVariables>(
    ShipperRateDocument,
    options
  )
}
export function useShipperRateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IShipperRateQuery, IShipperRateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShipperRateQuery, IShipperRateQueryVariables>(
    ShipperRateDocument,
    options
  )
}
export type ShipperRateQueryHookResult = ReturnType<typeof useShipperRateQuery>
export type ShipperRateLazyQueryHookResult = ReturnType<typeof useShipperRateLazyQuery>
export type ShipperRateQueryResult = Apollo.QueryResult<
  IShipperRateQuery,
  IShipperRateQueryVariables
>
